export default __webpack_public_path__ + "static/media/header-home.c963fac3.svg";